import { select } from 'typed-redux-saga';
import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { memberApiV2 } from '../../lib/api';
import {
  getHealthRateEntriesV2,
  getVitalDataById,
  getVitalDataRanges,
} from '../../services/vital-data';
import { IPagination } from '../../types/life-id';
import { actions } from '../ducks/life-id';

function* getGeneralInfo({ payload }: any) {
  try {
    const req: any = yield* call(memberApiV2.getGeneralInfoById, payload.providerId, payload.id);
    yield put(actions.getGeneralInfoSuccess(req.data.data));
  } catch {
    yield put(actions.getGeneralInfoSuccess(null));
  }
}

function* getVitalData({ payload }: any) {
  try {
    const req: any = yield* call(getVitalDataById, payload.providerId, payload.id);
    yield put(actions.getVitalDataSuccess(req.data.data));
  } catch {
    yield put(actions.getVitalDataSuccess(null));
  }
}

function* getBehavioralData({ payload }: any) {
  try {
    const req: any = yield* call(memberApiV2.getBehavioralDataById, payload);
    yield put(actions.getBehavioralDataSuccess(req.data.data));
  } catch {
    yield put(actions.getBehavioralDataSuccess(null));
  }
}

function* getBehavioralTimelineDataById({ payload }: any) {
  try {
    const req: any = yield* call(
      memberApiV2.getBehavioralTimelineDataById,
      payload.id,
      payload.type,
      payload.params,
    );
    yield put(actions.getBehavioralTimelineDataByIdSuccess(req.data.data));
  } catch {
    yield put(actions.getBehavioralTimelineDataByIdSuccess(null));
  }
}

function* getVitalDataIntervals({ payload }: any) {
  try {
    const req: any = yield* call(getVitalDataRanges, payload.providerId, payload.id);
    yield put(actions.getVitalDataIntervalsSuccess(req.data.data));
  } catch {
    yield put(actions.getVitalDataIntervalsSuccess(null));
  }
}

// const V2_TYPES = ['WAIST', 'BMI', 'bmi'];

function* getVitalDataItems({ payload }: any) {
  try {
    // @ts-ignore
    const pagination: IPagination = yield select((state) => state.lifeId.searchPagination);
    const req: any = yield* call(
      getHealthRateEntriesV2,
      payload.userId,
      payload.urlPart,
      payload.increasePage ? pagination.current + 1 : pagination.current,
      pagination.pageSize,
      payload.providerId,
      payload.range,
    );
    yield put(
      actions.getVitalDataItemsSuccess({
        pagination: req.data.data.pagination,
        items: req.data.data.items,
      }),
    );
  } catch {
    yield put(
      actions.getVitalDataItemsSuccess({
        pagination: { total: 0, pageSize: 20, current: 1, sortBy: 'name', direction: 'ASC' },
        items: [] as any[],
      }),
    );
  }
}

function* lifeIdSaga() {
  yield takeLatest(actions.getGeneralInfoRequest, getGeneralInfo);
  yield takeLatest(actions.getVitalDataRequest, getVitalData);
  yield takeLatest(actions.getBehavioralDataRequest, getBehavioralData);
  yield takeLatest(actions.getBehavioralTimelineDataByIdRequest, getBehavioralTimelineDataById);
  yield takeLatest(actions.getVitalDataIntervalsRequest, getVitalDataIntervals);
  yield takeLatest(actions.getVitalDataItemsRequest, getVitalDataItems);
}

export default lifeIdSaga;
